import React, { useMemo } from "react";
import ResourceArticleCard from "./ResourceArticleCard";

export default function ResourcesResultsSection({
  articles,
  loading,
  searchApplied,
  hasActiveFilters,
}) {
  const hasArticles = Array.isArray(articles) && articles.length > 0;

  const emptyMessage = useMemo(() => {
    if (hasActiveFilters || (searchApplied || "").trim()) {
      return "No articles match your filters. Try changing or clearing them.";
    }
    return "No articles are published yet. Check back soon.";
  }, [hasActiveFilters, searchApplied]);

  return (
    <section className="twentytwentysix-content__section">
      {loading && (
        <p className="twentytwentysix-content__copy">Loading articles…</p>
      )}

      {!loading && (
        <>
          <div className="twentytwentysix-content__mlist-results-header">
            <h2 className="twentytwentysix-content__subtitle">
              {hasArticles ? `Articles (${articles.length})` : "Articles"}
            </h2>
          </div>

          {hasArticles ? (
            <ul className="twentytwentysix-content__list twentytwentysix-content__list--no-bullets twentytwentysix-content__listing-grid">
              {articles.map((article) => (
                <ResourceArticleCard key={article.slug} article={article} />
              ))}
            </ul>
          ) : (
            <div className="twentytwentysix-content__empty-listings">
              <p className="twentytwentysix-content__copy">{emptyMessage}</p>
            </div>
          )}
        </>
      )}
    </section>
  );
}

